export enum LoginAction {
	Register = 'register',
	Login = 'login',
}

export const REDIRECT_TO_QUERY = 'redirectTo';
